"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _item = _interopRequireDefault(require("./item.styles"));
var baseStyle = {
  item: _item["default"]
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.List, {
  baseStyle: baseStyle
});